export default {
  useMoreAddress: 'Andere Adresse verwenden',
  hideAddress: 'Adresse ausblenden',
  productInventory: 'Warenliste',
  tag: 'Etikett',
  retainTag: 'Reserviertes Etikett',
  delTag: 'Etikett entfernen',
  externalPack: 'Umverpackung',
  packDetail: 'Verpackungsdetails',
  postLine: 'Versandroute',
  selectLine: 'Route auswählen',
  editLine: 'Route bearbeiten',
  service: 'Service',
  cancelServe: 'Service stornieren',
  previewPackage: 'Paketvorschau',
  postCountry: 'Versandland',
  packageNo: 'Paketnummer',
  deliver: 'Liefern an',
  packageDetail: 'Paketdetails',
  addressInfo: 'Adressinformationen',
  voWeight: 'Volumengewicht',
  firstWeight: 'Anfangsgewicht',
  continueWeight: 'Folgegewicht',
  actWeight: 'Tatsächliches Gewicht',
  packageStatus: 'Paketstatus',
  freightDetail: 'Kosteninformationen',
  declareCurrency: 'Deklarationswährung',
  selfDeclare: 'Eigenständige Deklaration',
  packageDeclarePrice: 'Gesamtbetrag der Paketdeklaration',
  youPackageProduct: 'Die Waren in Ihrem Paket',
  editYourDeclare: 'Bitte bearbeiten Sie Ihre Deklarationsinformationen',
  startDeclare: 'Deklaration starten',
  declareType: 'Art der Deklaration',
  productNo: 'Produkt-ID',
  declareProductPrice: 'Deklarierter Einzelpreis',
  declareTotalPrice: 'Gesamtbetrag der deklarierten Waren',
  editDeclare: 'Deklaration bearbeiten',
  declareLinePriceHint:
    'Der niedrigste Gesamtbetrag für die aktuelle Linie: {min}, der höchste: {max}',
  classMaxNumHint: 'Die Anzahl einzelner Kategorien hat das Limit {max} erreicht',
  addDeclareProduct: 'Deklarierte Ware hinzufügen',
  plsConfirmInfo: 'Bitte bestätigen Sie die Informationen',
  wipePackProduct: 'Unverpackte Waren',
  foldPackProduct: 'Faltbare Waren',
  wipeTagProduct: 'Unbeschriftete Waren',
  aboutCalcWeightExplain:
    'Da das Paket derzeit nicht verpackt ist, kennen wir das tatsächliche Gewicht des Pakets in dieser Phase nicht. Daher können wir uns nur auf einige vorhandene Parameter verlassen, um das Gewicht des Pakets zu schätzen, um die Anzahlung zu erheben. Nachdem das Paket verpackt und das tatsächliche Gewicht ermittelt wurde, wird der Mehr- oder Minderbetrag zurückerstattet.',
  expressInfo: 'Logistikinformationen',
  deliveryMode: 'Versandart',
  targetCountry: 'Zielland',
  cancelPackage: 'Paket stornieren',
  cancelPackageHint:
    'Bestätigt, dieses Paket zu stornieren? Nach der Stornierung können Sie es nicht wiederherstellen.',
  isDelPackage: 'Bestätigt, das Paket dauerhaft zu löschen?',
  delPackageHint:
    'Nach dem dauerhaften Löschen können Sie das Paket nicht mehr einsehen, bitte seien Sie vorsichtig!',
  receivedTips: 'Ihr Paket ist eingegangen, willkommen zur erneuten Nutzung',
  packageQuestion: 'Es gibt ein Problem mit der Zustellung des Pakets, Sie können',
  afterSale: 'Kundendienst beantragen',
  repair: 'Nachzahlung',
  ucan: 'Sie können',
  clickAdd: 'Klicken Sie auf Hinzufügen',
  addCategoryTips: 'Es gibt keinen Produktnamen, den Sie deklarieren möchten',
  noCarrierLines: 'Es sind keine Versandrouten verfügbar',
  confirmPackageTitle: 'Haben Sie den Erhalt der Ware bestätigt?',
  confirmPackageTips:
    'Um Ihre After-Sales-Rechte zu schützen, bestätigen Sie bitte den Erhalt, nachdem Sie überprüft haben, ob das Paket korrekt ist',
  receiptSuccess: 'Empfang erfolgreich',
  position: 'Position',
  time: 'Zeit',
  duty: 'Steuer-ID',
  inputTrueDuty: 'Bitte geben Sie die korrekte Steuer-ID ein',
  serveStatusEnum: {
    1: 'angepasst Fotos',
    2: 'Lagerfrist verlängern',
    5: 'Kundenspezifisches Video',
  },
  inputCareTime: 'Bitte wählen Sie die Lagerzeit',
  holder: {
    noInputSearch: 'Paketnummer/Produktnummer',
    inputEditDeclareInfo: 'Bitte bearbeiten Sie Ihre Deklarationsinformationen',
    packageRemark:
      'Wenn Sie weitere spezielle Anforderungen an das Paket haben, notieren Sie diese bitte hier',
    yourPriceSummary: 'Ihre Preisübersicht',
  },
  calcFee: 'Geschätzte Gebühr',
  realFee: 'Tatsächliche Gebühr',
  declare: {
    repeatDeclare: 'Art der doppelten Deklaration',
    addDeclareType: 'Bitte Deklarationstyp hinzufügen',
  },
  feeEnum: {
    totalAmount: 'Geschätzte Anzahlung',
    deposit: 'Geschätzte Kosten',
    overLongFee: 'Überlängengebühr',
    overWeightFee: 'Übergewichtsgebühr',
    remoteFee: 'Gebühren für entlegene Gebiete',
    feeCustoms: 'Logistikbearbeitungsgebühr',
    feeFuel: 'Treibstoffzuschlag',
    feeOperation: 'Bearbeitungsgebühr',
    feeService: 'Servicegebühr',
    valueAddedTax: 'Mehrwertsteuer',
    insuranceService: 'Prämie',
    incrementAmount: 'Mehrwertdienstgebühr',
    lineDiscount: 'Linienrabatt',
    discount: 'VIP-Rabatte',
    coupon: 'Gutschein auswählen',
    passwordDiscount: 'Rabattcode',
    orderPreDiscount: 'Warenrabatt',
    insuranceDiscount: 'Versicherungsrabatt',
    incrementDiscount: 'Mehrwertdienstangebot',
    preVolumeCal: 'Geschätzte Verwiegung',
    actDeposit: 'Fracht nach Verwiegung',
    actDepositAmount: 'Endgültige Zahlung',
  },
  ratePaymentEnum: {
    name: 'Steuerzahlungsmethode',
    0: 'Vom Empfänger bezahlt',
    1: 'Plattform-GST/MwSt.',
    2: 'Persönliche GST/MwSt.',
    3: 'Plattform-IOSS',
    4: 'Persönliche IOSS',
    5: 'Firmen-GST/MwSt.',
    6: 'Logistikdienstleister GST/MwSt.',
    7: 'Logistikdienstleister IOSS',
    8: 'Steuerfrei',
  },
  bagStatusEnum: {
    0: 'Normales Paket',
    1: 'Inlandsrücksendung',
    2: 'Internationale Rücksendung',
    3: 'Storniert',
    4: 'Aufladung ausstehend',
  },
  packageStatusEnum: {
    0: 'Wartet auf Bearbeitung',
    1: 'In Bearbeitung',
    2: 'Wird abgeholt',
    3: 'Abgeholt',
    4: 'Verpackung abgeschlossen',
    5: 'Gewogen',
    6: 'Frachtbrief gedruckt',
    7: 'Gescant',
    8: 'An Spediteur übergeben',
    9: 'Versandt',
    20: 'Erhalten',
  },
  declareEnum: {
    name: 'Deklarationsmethode',
    0: 'Systemdeklaration',
    1: 'Persönliche Deklaration',
  },
  backText: 'Zurück',
  packageInformation: 'Paketinformationen',
  parcelNumber: 'Paketnummer',
  noValidRule: 'Der deklarierte Betrag entspricht nicht den Regeln: {rule}',
  shippingAgree: 'acbuy-Paketversandvereinbarung',
  haveDiscountCode: 'Ich habe einen Rabattcode',
  inputDiscountCode: 'Geben Sie hier Ihren Rabattcode ein',
  expressNo: 'Sendungsnummer',
  shipping: 'Versand',
  taxation: 'Besteuerung',
  acCare: 'Ac Care',
  discountCode: 'Rabattcode',
  coupon: 'Gutschein',
  rangeDeclare: 'Ihr deklarierter Gesamtbetrag überschreitet den Bereich',
  noCouponData: 'Es gibt keine Gutscheine, die den Versandrabattbedingungen entsprechen.',
  exchange: 'Umtausch',
  'i18n-000001': 'Material',
  'i18n-000002': 'Farbe',
  'i18n-000003': 'Modell/Größe',
  'i18n-000004': 'Material',
  'i18n-000005': 'Deklarieren oder nicht',
  'i18n-000006': 'Freundliche Erinnerung',
  'i18n-000007':
    'Nach dem Absenden wird Acbuy die Deklarationsinformationen nicht mehr ändern. Wenn die Vorabfertigung fehlschlägt, werden wir den Versand trotzdem fortsetzen.',
  'i18n-000008':
    '1. Gemäß den Anforderungen des brasilianischen Zolls geben Sie bitte Name, Material, Farbe und Modell/Größe detailliert an, und der Gesamtname der Deklaration sollte 5 nicht überschreiten;',
  'i18n-000009':
    '2. Da kleine Pakete aus Brasilien für den persönlichen Gebrauch bestimmt sind, werden mehrere gleichzeitig beim Zoll eintreffende Pakete einbehalten. Bitte holen Sie mehrere Artikel separat ab;',
  'i18n-000010':
    '3. Es wird empfohlen, dass ein einzelnes Paket 4 kg nicht überschreitet und jede Ware mindestens 3 USD deklariert wird. Bei hochwertigen Produkten (Spielkonsolen, Mobiltelefone, Tablets, Computer usw.) deklarieren Sie wahrheitsgemäß, um Zollbeschlagnahmungen zu vermeiden;',
  'i18n-000011':
    '4. Lokaler Steuersatz in Brasilien: 17 % ICMS + 20 % Zoll werden für die Deklaration von weniger als 50 $ und 17 % ICMS + 60 % Zoll für die Deklaration von mehr als 50 $ angewendet.',
  'i18n-000012':
    '5. Bitte beachten Sie die SMS und E-Mails nach Ankunft des Pakets in Brasilien und zahlen Sie die Steuern rechtzeitig',
  'i18n-000013': '{num} Artikel',
  'i18n-000014': 'Produktname',
  cartonWarning:
    'Ihr Paket ist zu groß oder zu schwer. Wir empfehlen die Verwendung eines Kartons, um eine bessere Komprimierung zu erreichen und das Risiko von Schäden während des Versands zu verringern.',
  'i18n-0000003': 'Paketnummer',
  'i18n-0000004': 'Einreichungszeit',
  'i18n-0000005': 'Geschätztes Volumen',
  'i18n-0000006': 'Geschätztes Gewicht',
  'i18n-0000007': 'Geschätzte Kosten',
  'i18n-0000009': 'Versandart',
  'i18n-0000010': 'Sendungsnummer',
  'i18n-0000011': 'Zahlung ausstehend',
  'i18n-0000017': 'Gutscheinrabatt',
  'i18n-0000018': 'Lieferadresse',
  'i18n-0000019': 'Deklarationsinformationen',
  'i18n-0000020': 'Produktdeklarationsname',
  'i18n-0000021': 'Deklarierter Betrag ($)',
  'i18n-0000022': 'Menge',
  'i18n-0000023': 'Zwischensumme ($)',
  'i18n-0000024': 'Gesamtdeklarationsbetrag',
  'i18n-0000025': 'Produktinformationen',
  'i18n-0000026': 'Produkt',
  'i18n-0000027': 'Gewicht (g)',
  'i18n-0000028': 'Volumen (cm³)',
  'i18n-0000029': 'Verpackungsdetails',
  'i18n-0000033': 'Rückerstattung ausstehend',
  'i18n-0000034': 'Warten auf zusätzliche Zahlung',
  'i18n-0000035': 'Tatsächliches Volumen',
  'i18n-0000036': 'Berechnetes Gewicht',
  'i18n-0000037': 'Tatsächliche Kosten',
  'i18n-0000038': 'Tatsächliche Zahlung',
  'i18n-0000039': 'Paketfotos',
  'i18n-0000040': 'Paketrechnung herunterladen',
  'i18n-0000041': 'Zurückerstattet an das Wallet-Guthaben',
  'i18n-0000042': 'Rück.',
  'i18n-0000043': 'Zusätzliche Zahlung geleistet',
  'i18n-0000046': 'Erweitern',
  'i18n-0000047': 'Einklappen',
  'i18n-0000048': 'Logistik-Tracking',
  'i18n-0000049': 'Wiegeinformationen',
  'i18n-0000050': 'Rückerstattung',
  'i18n-0000051': 'Erwartet im Wallet innerhalb von 72 Stunden',
  samePreviewTips:
    'Dieses Probe-Paket wurde bereits eingereicht. Möchten Sie es erneut einreichen?',
  confirmSubmitTitle: 'Bestätigen und fortfahren',
  confirmSubmitText: 'Bitte bestätigen Sie Ihre Lieferadresse:',
  confirmSubmitContent: `Lieferadresse: {address}

Wichtiger Hinweis: Das angezeigte abrechenbare Gewicht ist ein geschätzter Wert. Das endgültige Abrechnungsgewicht basiert auf dem tatsächlich gemessenen Gewicht nach der Verpackung und wird in der Regel nach dem höheren Wert von Volumengewicht oder tatsächlichem Gewicht berechnet. Sollte es Abweichungen zwischen dem geschätzten und dem endgültigen Betrag geben, erfolgt eine Anpassung nach dem Prinzip „Erstattung oder Nachzahlung“.`,
}
